import { TemplateService } from '../../../../../services/template.service';
import { Number2textThService } from '../../../../../services/number2text-th.service';
import { FormBuilder, Validators } from '@angular/forms';
import { combineLatest, of, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ApiService } from '../../../../../services/api.service';
import Decimal from 'decimal.js-light';
import { TranslateService } from '@ngx-translate/core';
import { CALENDAR_LOCALE } from '../../../../../services/constant';
import * as moment from 'moment';
var LineItemFormComponent = (function () {
    function LineItemFormComponent(formBuilder, template, number2text_th, apiService, translateService) {
        var _this = this;
        this.formBuilder = formBuilder;
        this.template = template;
        this.number2text_th = number2text_th;
        this.apiService = apiService;
        this.translateService = translateService;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.isSellerHeadOffice = false;
        this.isBuyerHeadOffice = false;
        this.isDisableAddDiscount = false;
        this.vats = [
            { label: 'Non-Vat', value: 'non-vat' },
            { label: 'Vat 0%', value: '0' },
            { label: 'Vat 7%', value: '7' }
        ];
        this.vatValue = {
            '0': 0,
            '7': 0.07
        };
        this.receiptVats = [
            { label: 'Empty', value: '' },
            { label: 'Non-Vat', value: 'non-vat' },
            { label: 'Vat 0%', value: '0' },
            { label: 'Vat 7%', value: '7' }
        ];
        this.paymentChoices = [];
        this.creditCardChoices = [
            { label: "Visa", value: "Visa" },
            { label: "Master", value: "Master" },
            { label: "American Express", value: "American Express" },
            { label: "JCB", value: "JCB" },
            { label: "Union Pay", value: "Union Pay" },
            { label: "Alipay & Wechat", value: "Alipay & Wechat" },
            { label: "Diners Club", value: "Diners Club" },
        ];
        this.bankChoices = [
            { label: "SCB", value: "SCB" },
            { label: "BBL", value: "BBL" },
            { label: "KTB", value: "KTB" },
        ];
        this.paymentGatewayChoices = [
            { label: "Omise/Opn", value: "Omise/Opn" },
            { label: "Reddot", value: "Reddot" },
            { label: "Stribe", value: "Stribe" },
            { label: "iOL Pay", value: "iOL Pay" },
        ];
        this.onlineShopChoices = [
            { label: "Megatix", value: "Megatix" },
            { label: "E-Voucher", value: "E-Voucher" },
            { label: "Other", value: "Other" },
        ];
        this.product_id = 0;
        this.calendarLocale = CALENDAR_LOCALE.EN;
        this.validateNegative = function (control) {
            var isNegative = Boolean(!(_this.nonVATAmount.isNegative() || _this.vat0Amount.isNegative() || _this.vatAmount.isNegative()));
            return timer(300).pipe(switchMap(function () {
                return (isNegative) ? of(null) : new Promise(function (resolve) { return resolve({ vatAmountNegative: true }); });
            }));
        };
    }
    LineItemFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translateService.onLangChange.subscribe(function (event) {
            _this.setDocumentTypes();
            _this.loadPaymentChoices();
            _this.calendarLocale = event.lang === 'en'
                ? CALENDAR_LOCALE.EN
                : CALENDAR_LOCALE.TH;
        });
        this.setDocumentTypes();
        this.loadPaymentChoices();
        this.createLineItemForm();
        this.lineItemForm.get('items').valueChanges.subscribe(function () { _this.calVAT(); });
        this.lineItemForm.get('endBillDiscountList').valueChanges.subscribe(function () { _this.calVAT(); });
        this.lineItemForm.get('paymentMethods').valueChanges.subscribe(function () { _this.calVAT(); });
        // any time the inner form changes update the parent of any change
        this.createSubscriptions();
        this.getProduct();
    };
    LineItemFormComponent.prototype.loadPaymentChoices = function () {
        this.paymentChoices = [
            {
                label: this.translateService.instant("ISSUE-TEXT.PAYMENT.CASH"),
                value: 'cash',
            },
            {
                label: this.translateService.instant("ISSUE-TEXT.PAYMENT.CHEQUE"),
                value: 'cheque',
            },
            {
                label: this.translateService.instant("ISSUE-TEXT.PAYMENT.CREDIT-CARD"),
                value: 'credit_card',
            },
            {
                label: this.translateService.instant("ISSUE-TEXT.PAYMENT.BANK-TRANSFER"),
                value: 'bank_transfer',
            },
            {
                label: this.translateService.instant("ISSUE-TEXT.PAYMENT.PAYMENT-GATEWAY"),
                value: 'payment_gateway',
            },
            {
                label: this.translateService.instant("ISSUE-TEXT.PAYMENT.ONLINE-SHOP"),
                value: 'online_shop',
            },
            {
                label: this.translateService.instant("ISSUE-TEXT.PAYMENT.OTHER"),
                value: 'other',
            },
        ];
    };
    LineItemFormComponent.prototype.calVAT = function () {
        var vat = new Decimal(0);
        var vat7Amount = this.vatAmount.minus(this.vat0Amount);
        vat = vat.add(vat7Amount.mul(this.vatValue['7']));
        this.vat.setValue(vat.toDecimalPlaces(3).toDecimalPlaces(2).toString());
    };
    LineItemFormComponent.prototype.writeValue = function (value) {
        if (value) {
            this.lineItemForm.setValue(value);
            this.onChange(value);
            this.onTouched();
        }
    };
    LineItemFormComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    LineItemFormComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    // communicate the inner form validation to the parent form
    LineItemFormComponent.prototype.validate = function (_control) {
        var _this = this;
        return new Promise(function (resolve) {
            return _this.lineItemForm.valid ? resolve(null) : resolve({ lineItemForm: { valid: false } });
        });
    };
    LineItemFormComponent.prototype.createSubscriptions = function () {
        var _this = this;
        // Subscribe to valueChanges and statusChanges
        this.subscription = combineLatest([this.lineItemForm.valueChanges, this.lineItemForm.statusChanges]).subscribe(function () {
            var calculateValue = {
                amountText: _this.amountText,
                matchedABB: _this.matchedAbbValue,
                subTotal: _this.subTotal.toFixed(2),
                discountTotal: _this.discountTotal.toFixed(2),
                balance: _this.balance.toFixed(2),
                vat: _this.vat.value ? _this.vat.value : '',
                nonVATAmount: _this.nonVATAmount ? _this.nonVATAmount.toFixed(2) : '',
                vat0Amount: _this.vat0Amount ? _this.vat0Amount.toFixed(2) : '',
                vatAmount: _this.vatAmount ? _this.vatAmount.toFixed(2) : '',
                netTotal: _this.netTotal.toFixed(2),
                correctAmount: _this.correctAmount.toFixed(2),
                endOfBillDiscount: _this.endOfBillDiscount.toFixed(2),
                items: _this.items.value.map(function (item, index) { return ({
                    productID: item.productID,
                    description: item.description,
                    quantity: item.quantity,
                    unit: item.unit,
                    unitPrice: item.unitPrice,
                    discount: item.discount,
                    total: _this.getTotal(index).toFixed(2),
                    lineVAT: item.lineVAT,
                    note: item.note,
                }); }),
                paymentMethods: _this.paymentMethods.value.map(function (payment) { return ({
                    payment_type: payment.paymentType,
                    note: payment.note,
                    cheque_no: payment.chequeNo,
                    cheque_bank: payment.chequeBank,
                    cheque_date: payment.chequeDate ? moment(payment.chequeDate).format('DD/MM/YYYY') : '',
                    option_type: payment.optionType,
                    transfer_date: payment.transferDate ? moment(payment.transferDate).format('DD/MM/YYYY') : '',
                }); }),
                paymentOption: _this.abbData ? _this.abbData.payment_type : '',
            };
            _this.onChange(Object.assign({}, _this.lineItemForm.getRawValue(), calculateValue));
            _this.onTouched();
        });
    };
    LineItemFormComponent.prototype.setDocumentTypes = function () {
        var _this = this;
        this.documentTypes = this.template.getDropdown();
        if (this.isCreditNote || this.isDebitNote) {
            this.documentTypes.shift();
        }
        else {
            this.documentTypes = this.documentTypes.filter(function (element) { return element.value === _this.documentType; });
        }
    };
    Object.defineProperty(LineItemFormComponent.prototype, "isCreditNote", {
        get: function () {
            return this.documentType === 'credit_note';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "isDebitNote", {
        get: function () {
            return this.documentType === 'debit_note';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "isReceipt", {
        get: function () {
            return this.documentType === 'receipt';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "isReceiptTaxInvoice", {
        get: function () {
            return this.documentType === 'receipt_tax_invoice';
        },
        enumerable: true,
        configurable: true
    });
    LineItemFormComponent.prototype.createLineItemForm = function () {
        this.lineItemForm = this.formBuilder.group({
            items: this.formBuilder.array([
                this.formBuilder.group({
                    productID: [null],
                    description: [null, Validators.required],
                    quantity: ['1', Validators.required],
                    unit: [null],
                    unitPrice: ['0.00', Validators.required],
                    discount: [null],
                    lineVAT: ['7'],
                    note: [null],
                })
            ]),
            endBillDiscountList: this.formBuilder.array([
                this.formBuilder.group({
                    endBillDiscount: [null],
                    typeDiscount: ['7']
                })
            ]),
            discountReason: [null],
            originalAmount: (this.isCreditNote || this.isDebitNote) ? [null, Validators.required] : [null],
            originalVAT: (this.isCreditNote || this.isDebitNote) ? [null, Validators.required] : [null],
            nonVATAmount: [null],
            vat0Amount: [null],
            vatAmount: [null],
            vat: [null],
            endOfBillDiscount: [null],
            percentVAT: ['7'],
            paymentOption: [null],
            paymentMethods: this.formBuilder.array([
                this.formBuilder.group({
                    paymentType: [null],
                    note: [null],
                    chequeNo: [null],
                    chequeDate: [null],
                    chequeBank: [null],
                    optionType: [null],
                    transferDate: [null],
                }, { validator: this.validatePaymentMethods })
            ])
        });
        if (this.documentInformation && this.documentInformation.line_items) {
            this.updateLineItemsForm(this.documentInformation);
        }
    };
    LineItemFormComponent.prototype.validatePaymentMethods = function (group) {
        var paymentType = group.get('paymentType');
        var chequeNo = group.get('chequeNo');
        var chequeDate = group.get('chequeDate');
        var chequeBank = group.get('chequeBank');
        var optionType = group.get('optionType');
        var transferDate = group.get('transferDate');
        var setRequiredError = function (control, required) {
            if (required) {
                control.setErrors({ 'required': true });
            }
            else {
                control.setErrors(null);
            }
        };
        if (!paymentType.value) {
            setRequiredError(paymentType, true);
        }
        else {
            if (paymentType.value === 'cheque') {
                setRequiredError(chequeNo, !chequeNo.value);
                setRequiredError(chequeDate, !chequeDate.value);
                setRequiredError(chequeBank, !chequeBank.value);
            }
            else if (['credit_card', 'payment_gateway', 'online_shop'].includes(paymentType.value)) {
                setRequiredError(optionType, !optionType.value);
            }
            else if (paymentType.value === 'bank_transfer') {
                setRequiredError(optionType, !optionType.value);
                setRequiredError(transferDate, !transferDate.value);
            }
        }
        return null;
    };
    LineItemFormComponent.prototype.updateLineItemsForm = function (documentInformation) {
        var _this = this;
        var lineItemArray = this.lineItemForm.get('items');
        documentInformation.line_items.forEach(function (item, index) {
            var itemValues = {
                productID: item.item_number,
                description: item.product_name,
                quantity: item.quantity,
                unit: item.unit,
                unitPrice: item.unit_price,
                discount: item.net_discount_or_charge,
                lineVAT: item.percent_vat.match(/^\d+/)[0],
                note: item.note,
            };
            try {
                lineItemArray.at(index).patchValue(itemValues);
            }
            catch (e) {
                lineItemArray.push(_this.formBuilder.group({
                    productID: [null],
                    description: [null, Validators.required],
                    quantity: ['1', Validators.required],
                    unit: [null],
                    unitPrice: ['0.00', Validators.required],
                    discount: [null],
                    lineVAT: ['7'],
                    note: [null],
                }));
                lineItemArray.at(index).patchValue(itemValues);
            }
        });
        lineItemArray.push(this.formBuilder.group({
            productID: [null],
            description: [null, Validators.required],
            quantity: ['1', Validators.required],
            unit: [null],
            unitPrice: ['0.00', Validators.required],
            discount: [null],
            lineVAT: ['7'],
            note: [null],
        }));
        this.lineItemForm.get('vat').patchValue(documentInformation.total_items.vat);
        this.lineItemForm.get('discountReason').patchValue(documentInformation.total_items.discount_or_charge_reason);
        this.lineItemForm.get('originalAmount').patchValue(documentInformation.total_items.original_amount_before_vat ? documentInformation.total_items.original_amount_before_vat : null);
        this.lineItemForm.get('originalVAT').patchValue(documentInformation.total_items.original_amount_vat ? documentInformation.total_items.original_amount_vat : null);
        var lineItemTotalArray = this.lineItemForm.get('endBillDiscountList');
        lineItemTotalArray.at(0).get('endBillDiscount').patchValue(documentInformation.total_items.discount_or_charge);
        this.documentIssueForm.get('lineItemForm').patchValue(this.lineItemForm.value);
    };
    Object.defineProperty(LineItemFormComponent.prototype, "items", {
        get: function () {
            return this.lineItemForm.get('items');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "paymentMethods", {
        get: function () {
            return this.lineItemForm.get('paymentMethods');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "endBillDiscountList", {
        get: function () {
            return this.lineItemForm.get('endBillDiscountList');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "discountReason", {
        get: function () {
            return this.lineItemForm.get('discountReason');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "originalAmount", {
        get: function () {
            return this.lineItemForm.get('originalAmount');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "originalVAT", {
        get: function () {
            return this.lineItemForm.get('originalVAT');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "percentVAT", {
        get: function () {
            return this.lineItemForm.get('percentVAT');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "vat", {
        get: function () {
            return this.lineItemForm.get('vat');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "paymentOption", {
        get: function () {
            return this.lineItemForm.get('paymentOption');
        },
        enumerable: true,
        configurable: true
    });
    LineItemFormComponent.prototype.getPaymentMethodControl = function (index, controlName) {
        return this.paymentMethods.controls[index].get(controlName);
    };
    LineItemFormComponent.prototype.showDropdownOption = function (index) {
        var paymentType = this.getPaymentMethodControl(index, 'paymentType').value || '';
        return ['credit_card', 'bank_transfer', 'payment_gateway', 'online_shop'].includes(paymentType);
    };
    LineItemFormComponent.prototype.showNoteBox = function (index) {
        var paymentType = this.getPaymentMethodControl(index, 'paymentType').value || '';
        return ['cash', 'online_shop', 'other'].includes(paymentType);
    };
    LineItemFormComponent.prototype.addPaymentMethod = function () {
        this.paymentMethods.push(this.formBuilder.group({
            paymentType: [null],
            note: [null],
            chequeNo: [null],
            chequeDate: [null],
            chequeBank: [null],
            optionType: [null],
            transferDate: [null],
        }));
    };
    LineItemFormComponent.prototype.removePaymentMethod = function (index) {
        this.paymentMethods.removeAt(index);
    };
    LineItemFormComponent.prototype.resetPaymentDetail = function (index) {
        this.getPaymentMethodControl(index, 'note').setValue(null);
        this.getPaymentMethodControl(index, 'chequeNo').setValue(null);
        this.getPaymentMethodControl(index, 'chequeDate').setValue(null);
        this.getPaymentMethodControl(index, 'chequeBank').setValue(null);
        this.getPaymentMethodControl(index, 'optionType').setValue(null);
        this.getPaymentMethodControl(index, 'transferDate').setValue(null);
    };
    LineItemFormComponent.prototype.getPaymentType = function (index) {
        return this.paymentMethods.controls[index].get('paymentType');
    };
    LineItemFormComponent.prototype.getPaymentChequeNO = function (index) {
        return this.paymentMethods.controls[index].get('chequeNo');
    };
    LineItemFormComponent.prototype.getPaymentBank = function (index) {
        return this.paymentMethods.controls[index].get('chequeBank');
    };
    LineItemFormComponent.prototype.getPaymentChequeDate = function (index) {
        return this.paymentMethods.controls[index].get('chequeDate');
    };
    LineItemFormComponent.prototype.getPaymentOptionType = function (index) {
        return this.paymentMethods.controls[index].get('optionType');
    };
    LineItemFormComponent.prototype.getPaymentTransferDate = function (index) {
        return this.paymentMethods.controls[index].get('transferDate');
    };
    LineItemFormComponent.prototype.getProductID = function (index) {
        return this.items.controls[index].get('productID');
    };
    LineItemFormComponent.prototype.getDescription = function (index) {
        return this.items.controls[index].get('description');
    };
    LineItemFormComponent.prototype.getQuantity = function (index) {
        return this.items.controls[index].get('quantity');
    };
    LineItemFormComponent.prototype.getUnit = function (index) {
        return this.items.controls[index].get('unit');
    };
    LineItemFormComponent.prototype.getUnitPrice = function (index) {
        return this.items.controls[index].get('unitPrice');
    };
    LineItemFormComponent.prototype.getDiscount = function (index) {
        return this.items.controls[index].get('discount');
    };
    LineItemFormComponent.prototype.getLineVAT = function (index) {
        return this.items.controls[index].get('lineVAT');
    };
    LineItemFormComponent.prototype.getTypeDiscount = function (index) {
        return this.endBillDiscountList.controls[index].get('typeDiscount');
    };
    LineItemFormComponent.prototype.getEndBillDiscount = function (index) {
        return this.endBillDiscountList.controls[index].get('endBillDiscount');
    };
    LineItemFormComponent.prototype.getTotal = function (index) {
        var quantity = new Decimal(this.getQuantity(index).value || 0);
        var unitPrice = new Decimal(this.getUnitPrice(index).value || 0);
        var discount = new Decimal(this.getDiscount(index).value || 0);
        var total = quantity.mul(unitPrice).minus(discount);
        return total.toDecimalPlaces(2);
    };
    Object.defineProperty(LineItemFormComponent.prototype, "endOfBillDiscount", {
        get: function () {
            var endOfBillDiscount = new Decimal(0);
            for (var index = 0; index < this.endBillDiscountList.length; index++) {
                var discount = new Decimal(this.getEndBillDiscount(index).value || 0);
                endOfBillDiscount = endOfBillDiscount.add(discount);
            }
            return endOfBillDiscount.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "subTotal", {
        get: function () {
            var subTotal = new Decimal(0);
            for (var index = 0; index < this.items.length; index++) {
                var quantity = new Decimal(this.getQuantity(index).value || 0);
                var unitPrice = new Decimal(this.getUnitPrice(index).value || 0);
                subTotal = subTotal.add(quantity.mul(unitPrice));
            }
            return subTotal.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "vatAmount", {
        get: function () {
            var vatAmount = new Decimal(0);
            for (var index = 0; index < this.items.length; index++) {
                if (this.getLineVAT(index).value == '7') {
                    vatAmount = vatAmount.add(this.getTotal(index));
                }
            }
            for (var index = 0; index < this.endBillDiscountList.length; index++) {
                if (this.getTypeDiscount(index).value == '7') {
                    var discount = new Decimal(this.getEndBillDiscount(index).value || 0);
                    vatAmount = vatAmount.minus(discount);
                }
            }
            return vatAmount.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "nonVATAmount", {
        get: function () {
            var nonVATAmount = new Decimal(0);
            for (var index = 0; index < this.items.length; index++) {
                if (this.getLineVAT(index).value == 'non-vat') {
                    nonVATAmount = nonVATAmount.add(this.getTotal(index));
                }
            }
            for (var index = 0; index < this.endBillDiscountList.length; index++) {
                if (this.getTypeDiscount(index).value == 'non-vat') {
                    var discount = new Decimal(this.getEndBillDiscount(index).value || 0);
                    nonVATAmount = nonVATAmount.minus(discount);
                }
            }
            return nonVATAmount.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "vat0Amount", {
        get: function () {
            var vat0Amount = new Decimal(0);
            for (var index = 0; index < this.items.length; index++) {
                if (this.getLineVAT(index).value == '0') {
                    vat0Amount = vat0Amount.add(this.getTotal(index));
                }
            }
            for (var index = 0; index < this.endBillDiscountList.length; index++) {
                if (this.getTypeDiscount(index).value == '0') {
                    var discount = new Decimal(this.getEndBillDiscount(index).value || 0);
                    vat0Amount = vat0Amount.minus(discount);
                }
            }
            return vat0Amount.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "discountTotal", {
        get: function () {
            var discountTotal = new Decimal(0);
            for (var index = 0; index < this.items.length; index++) {
                var discount = new Decimal(this.getDiscount(index).value || 0);
                discountTotal = discountTotal.add(discount);
            }
            return discountTotal.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "balance", {
        get: function () {
            var balance = this.subTotal.minus(this.discountTotal).minus(this.endOfBillDiscount);
            return balance.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "netTotal", {
        get: function () {
            var vatValue = new Decimal(this.vat.value || 0);
            var netTotal = this.balance.add(vatValue);
            return netTotal.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "correctAmount", {
        get: function () {
            var correctAmount = new Decimal(0);
            var originalAmount = new Decimal(this.originalAmount.value || 0);
            if (this.isDebitNote) {
                correctAmount = originalAmount.add(this.balance);
            }
            else if (this.isCreditNote) {
                correctAmount = originalAmount.minus(this.balance);
            }
            return correctAmount.toDecimalPlaces(2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "amountText", {
        get: function () {
            return this.number2text_th.currencyFormat_Baht(this.netTotal.toString());
        },
        enumerable: true,
        configurable: true
    });
    LineItemFormComponent.prototype.addItem = function () {
        this.items.push(this.formBuilder.group({
            productID: [null],
            description: [null, Validators.required],
            quantity: ['1', Validators.required],
            unit: [null],
            unitPrice: ['0.00', Validators.required],
            discount: [null],
            lineVAT: ["7"],
            note: [null],
        }));
    };
    LineItemFormComponent.prototype.removeItem = function (index) {
        this.items.removeAt(index);
    };
    LineItemFormComponent.prototype.addEndBillDiscount = function () {
        this.endBillDiscountList.push(this.formBuilder.group({
            endBillDiscount: [null],
            typeDiscount: ['7']
        }));
        if (this.endBillDiscountList.length >= 3) {
            this.isDisableAddDiscount = true;
        }
    };
    LineItemFormComponent.prototype.removeEndBillDiscount = function (index) {
        this.endBillDiscountList.removeAt(index);
        if (this.endBillDiscountList.length < 3) {
            this.isDisableAddDiscount = false;
        }
    };
    Object.defineProperty(LineItemFormComponent.prototype, "showAbbNetTotal", {
        get: function () {
            if (!this.abbData || typeof this.abbData === 'string') {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineItemFormComponent.prototype, "matchedAbbValue", {
        get: function () {
            if (!this.abbData || typeof this.abbData === 'string') {
                return true;
            }
            var abbTotalPayment = new Decimal(this.abbData.total_payment);
            return this.netTotal.toFixed(2) === abbTotalPayment.toFixed(2);
        },
        enumerable: true,
        configurable: true
    });
    LineItemFormComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    LineItemFormComponent.prototype.getProduct = function () {
        var _this = this;
        this.apiService.getProductsList()
            .subscribe(function (data) {
            _this.products = data;
        });
    };
    LineItemFormComponent.prototype.setProduct = function (product, item) {
        if ((item.controls.productID.value !== null
            && item.controls.description.value !== null)
            && (product.product_id === undefined || product.name_en === undefined)) {
            var found = void 0;
            if (product.product_id === undefined) {
                found = this.products.find(function (x) { return x.name_en === item.controls.description.value; });
            }
            else if (product.name_en === undefined) {
                found = this.products.find(function (x) { return x.id === item.controls.productID.value; });
            }
            if (!found) {
                this.products.push({
                    id: item.controls.productID.value,
                    name_en: item.controls.description.value
                });
                product.product_id = item.controls.productID.value;
                product.name_en = item.controls.description.value;
            }
        }
        item.controls.productID.setValue(product.product_id);
        item.controls.description.setValue(product.name_en);
        item.controls.lineVAT.setValue(product.vat);
    };
    return LineItemFormComponent;
}());
export { LineItemFormComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/line-item-form/line-item-form.component.ts.pre-build-optimizer.js